// extracted by mini-css-extract-plugin
export var cardLayout = "_6j-1";
export var paginationContainer = "_6j-0";